import { type FC } from "react";

import { useAttorneyHelplineEnabled } from "@/shared/hooks/useAttorneyHelplineEnabled";

import { LegalAuthorityInfoStep } from "./LegalAuthorityInfoStep";

interface LegalAuthorityNoAttorneyStepProps {
  onBack: () => void;
  onContinue: () => void;
}

export const LegalAuthorityNoAttorneyStep: FC<LegalAuthorityNoAttorneyStepProps> = ({
  onBack,
  onContinue,
}) => {
  const helplineEnabled = useAttorneyHelplineEnabled();

  return (
    <LegalAuthorityInfoStep onBack={onBack} onContinue={onContinue}>
      <p>
        Many estates never need one. If yours does, we'll let you know upfront, and we can match you
        with an attorney who knows your state's estates.
      </p>
      {helplineEnabled && (
        <p>
          For quick legal questions along the way, our Estate Setup service includes 30 minutes with
          the attorney hotline.
        </p>
      )}
    </LegalAuthorityInfoStep>
  );
};
